module.exports = __webpack_public_path__ + "img/area_4.c700a5e3.png";